export var GenericUserJobType;
(function (GenericUserJobType) {
    GenericUserJobType["BUSINESS_DATA_APPEND"] = "business-data-append";
    GenericUserJobType["COMPANY_NAME_TO_DOMAIN"] = "company-name-to-domain";
    GenericUserJobType["SMARTAL"] = "smartal";
    GenericUserJobType["IMPRESSION_FORECASTING"] = "impression-forecasting";
})(GenericUserJobType || (GenericUserJobType = {}));
export var GenericUserJobStatus;
(function (GenericUserJobStatus) {
    GenericUserJobStatus["INITIATED"] = "initiated";
    GenericUserJobStatus["PROCESSING"] = "processing";
    GenericUserJobStatus["SUCCESS"] = "success";
    GenericUserJobStatus["ERROR"] = "error";
    GenericUserJobStatus["NO_RESULTS"] = "no-results";
})(GenericUserJobStatus || (GenericUserJobStatus = {}));
//# sourceMappingURL=GenericUserJob.js.map